import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import vuetify from './plugins/vuetify';
import Vuelidate from 'vuelidate'
import axios from 'axios'
import i18n from './i18n'

Vue.config.productionTip = false

const token = sessionStorage.getItem('jwt')
if (token) {
  axios.defaults.headers.common['Authorization'] = `Bearer ${token}`
  setInterval(() => {
    store.dispatch('refreshToken')
  }, 1000 * 60 * 5)
}

Vue.use(Vuelidate)

new Vue({
  router,
  store,
  vuetify,
  i18n,
  render: h => h(App)
}).$mount('#app')
